export default "__VITE_ASSET__dcbf4b90__"